import Vue from "@shared/vue-config";
import TheProfile from "./TheProfile.vue";
import VueCropper from "vue-cropperjs";
var vue = new Vue({
    el: "#app",
    components: {
        VueCropper: VueCropper,
        TheProfile: TheProfile,
    },
    data: {}
});
global.vue = vue;
global.VueCompile = Vue.compile;



//////////////////
// WEBPACK FOOTER
// ./app/profile/index.ts
// module id = 186
// module chunks = 4